import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const TTO_LABEL = { bono: "Bono TV", sesiones: "Sesiones TV", syntonic: "Syntonic", tomatis: "Tomatis", wivi: "Wivi" };
export const CITA_TTO = ["sesion_tv", "syntonic", "tomatis", "wivi"];

export const CitaTto = ({ f, setF }) => {
  const [ttos, setTtos] = useState([]);
  const pid = f.patient?.id || f.patient_id;
  const aplica = Boolean(pid && CITA_TTO.includes(f.tipo));
  useEffect(() => {
    if (!aplica) {
      setTtos([]);
      return;
    }
    api.get("/citas/tratamientos", { params: { patient_id: pid, tipo: f.tipo } }).then((r) => setTtos(r.data));
  }, [aplica, pid, f.tipo]);
  useEffect(() => {
    if (!ttos.length) {
      if (f.treatment_id && !aplica) setF((x) => ({ ...x, treatment_id: null, verificada: false }));
      return;
    }
    if (!ttos.some((t) => t.id === f.treatment_id)) setF((x) => ({ ...x, treatment_id: ttos.length === 1 ? ttos[0].id : null, verificada: false }));
  }, [ttos, f.treatment_id, aplica, setF]);
  if (!aplica) return null;
  if (!ttos.length) return <p className="col-span-2 text-[11px] text-amber-700" data-testid="appt-tto-none">Este paciente no tiene un tratamiento de este tipo en marcha: la cita no se apuntará en ningún tratamiento.</p>;
  return (
    <div className="col-span-2 grid grid-cols-2 gap-3 items-end">
      <label className="block text-[11px] font-semibold uppercase tracking-wider text-slate-500">Apuntar en el tratamiento
        <select data-testid="appt-tto" className="field-select mt-1" value={f.treatment_id || ""} onChange={(e) => setF((x) => ({ ...x, treatment_id: e.target.value || null }))}>
          <option value="">— Ninguno —</option>
          {ttos.map((t) => <option key={t.id} value={t.id}>{TTO_LABEL[t.tipo] || t.tipo}{t.modalidad ? ` · ${t.modalidad}` : ""}{t.fecha_inicio ? ` · desde ${t.fecha_inicio.split("-").reverse().join("/")}` : ""}</option>)}
        </select>
      </label>
      {f.id && f.treatment_id && (
        <label className="flex items-center gap-2 text-xs text-slate-700 pb-2">
          <input type="checkbox" checked={!!f.verificada} onChange={(e) => setF((x) => ({ ...x, verificada: e.target.checked }))} data-testid="appt-verificada" />
          Verificada en el tratamiento
        </label>
      )}
    </div>
  );
};
